<template lang="pug">
.doc-actions.mb-2
  div
    .dropdown.dropdown-right
      a.dropdown-toggle.btn(tabindex="0" data-tooltip="Ações" :disabled="loading")
        i.fa.fa-cog
        |  Ações
      ul.menu.text-left
        li.menu-item.py-1(v-if='!doc.permite_editar')
          router-link.c-hand.text-primary(:to='{ name: "fiscalizacao.docs.show.comentar" }')
            .columns
              .column
                btn-content(label='Comentar', icon='fa fa-comment')
              .column.col-auto
                i.fa.fa-chevron-right
        li.menu-item.py-1(v-if='doc.permite_atender')
          router-link.c-hand(:to='{ name: "fiscalizacao.docs.show.prazo_regularizar" }')
            .columns
              .column
                btn-content(label='Prazo Regularizar', icon='fa fa-calendar')
              .column.col-auto
                i.fa.fa-chevron-right
        li.menu-item.py-1(v-if='doc.verificar && doc.verificar.length > 0')
          router-link.c-hand(:to='{ name: "fiscalizacao.docs.show.verificar" }')
            .columns
              .column
                btn-content(label='Verificar', icon='fa fa-eye')
              .column.col-auto
                i.fa.fa-chevron-right
        li.menu-item.py-1(v-if='doc.permite_editar')
          router-link.c-hand.btn-primary(:to='{ name: "fiscalizacao.docs.edit.info" }')
            .columns
              .column
                btn-content(label='Editar rascunho', icon='fa fa-edit')
              .column.col-auto
                i.fa.fa-chevron-right
        li.menu-item.py-1(v-if='doc.permite_solicitar_revisao')
          router-link.c-hand(:to='{ name: "fiscalizacao.docs.show.solicitar_revisao" }')
            .columns
              .column
                btn-content(label='Solicitar revisão', icon='fa fa-edit')
              .column.col-auto
                i.fa.fa-chevron-right
        li.menu-item.py-1(v-if='doc.permite_revisar')
          router-link.c-hand.btn-primary(:to='{ name: "fiscalizacao.docs.revisao.info" }')
            .columns
              .column
                btn-content(label='Revisar', icon='fa fa-edit')
              .column.col-auto
                i.fa.fa-chevron-right
        li.menu-item.py-1(v-if='doc.permite_cancelar')
          router-link.c-hand.text-error(:to="{name: 'fiscalizacao.docs.show.cancelar'}")
            .columns
              .column
                btn-content(icon="fa fa-times" label="Cancelar")
              .column.col-auto
                i.fa.fa-chevron-right
        li.menu-item.py-1(v-if="doc.permite_ciencia")
          router-link.c-hand(:to="{name: 'fiscalizacao.docs.show.ciencia'}")
            .columns
              .column
                btn-content(label="Ciência" icon="fa fa-check")
              .column.col-auto
                i.fa.fa-chevron-right
        li.menu-item.py-1(v-if='!doc.permite_editar')
          router-link.c-hand.text-error(:to="{name: 'fiscalizacao.docs.show.manutencao'}")
            .columns
              .column
                btn-content(label="Manutenção" icon="fa fa-edit")
              .column.col-auto
                i.fa.fa-chevron-right
</template>

<script>
export default {
  props: {
    doc: { type: Object, require: true },
    loading: { type: Boolean },
  },
}
</script>

<style lang="stylus" scoped>
.doc-actions
  .dropdown
    .menu
      width 250px
  &.dropdown-bottom
    .dropdown
      .menu
        margin-bottom 10px
        bottom 100%
        // animation slide-up .15s ease 1
        top inherit
</style>
